import { OrderImageListInfo } from "./order_image_list_info.model";

/**
 * 商品画像情報画面の画像情報一覧クラス
 *
 * @export ImageListInfo
 * @class ImageListInfo
 */
export class ImageListInfo {
  constructor(
    // 編集フラグ
    public editFlg: boolean = false,
    // Pコード
    public pCode: string = null,
    // 部門コード
    public classCode: string = null,
    // 部門名
    public classNameKanji: string = null,
    // 商品名
    public guideGoodsName: string = null,
    // 規格名
    public guideStandardName: string = null,
    // マルチ・クロス
    public multiOrCrossFlg: string = null,
    // 表示用マルチ・クロス
    public displayMultiOrCross: string = null,
    // 遷移時確認
    public beforeUpdateImageChk: boolean = false,
    // 確認
    public imageChk: boolean = false,
    // 確認活性制御
    public imageChkDisabledFlg: boolean = false,
    // 注文コード・画像情報部
    public orderImageListInfo: OrderImageListInfo[] = []
  ) {}
}
  